import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { st, FormControl, Form, FormMessage, Button, Link } from "lib/index";
import AuthLayout from "modules/app/AuthLayout";
import { stateSelector, initializeView, initializeModel, updateModel, submit } from "./index";

@connect(
  (state) => ({
    model: stateSelector(state).form.model,
    valid: stateSelector(state).form.valid,
    submitLoading: stateSelector(state).form.submitLoading,
    errors: stateSelector(state).form.errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        initializeModel,
        updateModel,
        submit,
      },
      dispatch
    )
)
export default class LoginView extends React.PureComponent {
  componentDidMount() {
    const {
      next: redirectAfterLogin,
      email = null,
      test: testMode,
      test_locale: testLocale,
    } = this.props.location.query;
    this.props.initializeView({ redirectAfterLogin });
    this.props.initializeModel({ email, password: null });

    if (testMode) {
      this.props.initializeView({
        redirectAfterLogin: testLocale
          ? "/?c_by_saas_subdomain=partner-#{testLocale}"
          : "/?c_by_saas_subdomain=partner",
      });
      this.props.updateModel({ email: `testadmin-${testLocale || "en"}@tripsomnia.com`, password: "tripsomnia" });
      this.props.submit();
    }
  }

  handleModelPropChange(prop, value) {
    const { model, updateModel } = this.props;
    updateModel({
      ...model,
      [prop]: value,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.submit();
  }

  render() {
    const { model, submitLoading, valid, errors } = this.props;

    return (
      <AuthLayout.Container>
        <AuthLayout.Box title={I18n.t("papp.auth.LoginView.title")}>
          {model && (
            <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
              {!!errors.base && <FormMessage error={errors.base} />}

              <FormControl.InputFormGroup
                {...FormControl.addProps(`model.email`, { errors })}
                value={model.email}
                onChange={this.handleModelPropChange.bind(this, "email")}
                label={I18n.humanAttributeName("admin_user", "email")}
                type="email"
                required
              />

              <FormControl.InputFormGroup
                {...FormControl.addProps(`model.password`, { errors })}
                value={model.password}
                onChange={this.handleModelPropChange.bind(this, "password")}
                label={I18n.humanAttributeName("admin_user", "password")}
                type="password"
                required
              />

              <small style={{ display: "block", float: "left", lineHeight: "3rem" }}>
                <Link className="u-primaryLink" to="/send_reset_password_instructions">
                  {I18n.t("papp.auth.LoginView.send_reset_password_instructions_link")}
                </Link>
                <br />
              </small>

              <Button primary floated="right" type="submit" content={I18n.t("papp.auth.LoginView.submit")} />
            </Form>
          )}
        </AuthLayout.Box>

        <small hidden>
          <br />
          <Link className="u-greyLink" to="/send_confirmation_instructions">
            {I18n.t("papp.auth.LoginView.send_confirmation_instructions_link")}
          </Link>
          <br />
          <Link className="u-greyLink" to="/send_unlock_instructions">
            {I18n.t("papp.auth.LoginView.send_unlock_instructions_link")}
          </Link>
          <br />
        </small>
      </AuthLayout.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/LoginView/LoginView.jsx